<template>
    <v-container class="pa-0" style="min-height:100vh;max-width:none;">




        <v-row style="" align="center" justify="center" class="">
            <v-col cols="12" >


                <div class="mx-auto my-auto"  id="be_like_me" :style="{'transform':scale}" style="transform-origin: top left;height:600px;width:1000px;border: 4px solid #00796b;">
                    <StandardAlert :id_given="id_given"  :editable="true" :locked="lock_alert" ref="standard_alert" @boxfocus="handleFocus" v-if="!loading && type==='DONATION'" :data="donation_data" :setup="setup"></StandardAlert>
                    <GoalAlert :id_given="id_given"  :editable="true" :locked="lock_alert" ref="goal_alert" @boxfocus="handleFocus" v-else-if="!loading && type==='GOAL'" :data="donation_data" :setup="setup"></GoalAlert>

                </div>
            </v-col>
            <v-col style="max-width:1200px;">


                <v-row v-if="type==='DONATION'">
                    <v-col>

                        <v-tabs
                                v-model="edit_box_tab"
                                background-color="transparent"
                                grow
                        >
                            <v-tab
                                    @mouseenter="glow('bg_box'+id_given,true)"
                                    @mouseleave="glow('bg_box'+id_given,false)"
                            >
                                Bakgrundsbox
                            </v-tab>
                            <v-tab
                                    @mouseenter="glow('message_box'+id_given,true)"
                                    @mouseleave="glow('message_box'+id_given,false)"
                            >
                                Meddelandebox
                            </v-tab>
                            <v-tab
                                    @mouseenter="glow('name_box'+id_given,true)"
                                    @mouseleave="glow('name_box'+id_given,false)"
                            >
                                BOX-1
                            </v-tab>
                            <v-tab
                                    @mouseenter="glow('amount_box'+id_given,true)"
                                    @mouseleave="glow('amount_box'+id_given,false)"
                            >
                                BOX-2
                            </v-tab>

                        </v-tabs>

                        <v-tabs-items    v-if="!loading" dark v-model="edit_box_tab">

                            <v-tab-item eager transition="false" reverse-transition="false">
                                <v-btn
                                        @click="reset_bg"
                                        style="position: absolute;top:14px;right:10px;z-index: 3;"
                                        icon >
                                    <v-icon>mdi-redo</v-icon>
                                </v-btn>
                                <v-checkbox
                                        off-icon="mdi-eye-off"
                                        on-icon="mdi-eye"
                                        style="position: absolute;top:0;right:50px;z-index: 3;"
                                        color="gray"
                                        v-model="setup.BG_BOX.SHOW"
                                >
                                </v-checkbox>
                                <v-card style="" color="#252525" elevation="20" class="pa-12">
                                    <v-card-subtitle style="text-align:center;margin-bottom:0;margin-top:-40px;">- Animation -</v-card-subtitle>
                                    <v-row
                                            style="background:#1f1f1f;border-radius:10px;"

                                    >

                                        <v-col cols="8">
                                            <v-range-slider
                                                    v-model="setup.BG_BOX.RANGE"
                                                    :max="setup.DURATION"
                                                    :min="0"
                                                    :step="0.1"
                                                    hide-details
                                                    class="align-center"
                                                    ref="bg_box_range"

                                            >
                                                <template v-slot:prepend>
                                                    <v-text-field
                                                            v-model="setup.BG_BOX.RANGE[0]"
                                                            class="mt-0 pt-0"
                                                            hide-details

                                                            single-line
                                                            type="number"
                                                            style="width: 60px"
                                                            suffix="s"
                                                            @change="$set(setup.BG_BOX.RANGE, 0, $event)"
                                                    ></v-text-field>
                                                </template>
                                                <template v-slot:append>
                                                    <v-text-field
                                                            v-model="setup.BG_BOX.RANGE[1]"
                                                            class="mt-0 pt-0"
                                                            hide-details
                                                            single-line
                                                            suffix="s"
                                                            type="number"
                                                            :max="setup.DURATION"
                                                            style="width: 60px"
                                                            @change="$set(setup.BG_BOX.RANGE, 1, $event)"

                                                    ></v-text-field>
                                                </template>
                                            </v-range-slider>
                                        </v-col >

                                        <v-col cols="4">
                                            <v-select
                                                    style="margin-top: -8px;"
                                                    :items="animations"
                                                    label="Animation"
                                                    clearable
                                                    hide-details
                                                    v-model="setup.BG_BOX.ANIMATION"

                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-card-subtitle style="text-align:center;margin-bottom:0;">- Bakgrund -</v-card-subtitle>

                                    <v-row style="background:#1f1f1f;border-radius:10px;" justify="center" align="center">
                                        <v-col style="max-width:400px !important;" justify="center">
                                            <div class="text-center">

                                            <v-menu
                                                    v-model="background_color_menu"
                                                    :close-on-content-click="false"
                                                    :nudge-width="200"
                                                    offset-x
                                                    dark
                                                    content-class="color_menu"
                                            >
                                                <template v-slot:activator="{ on }">

                                                    <v-btn
                                                            style="text-shadow: 4px 4px 20px black;width:250px;"
                                                            class="mx-2 my-2"
                                                            :color=setup.BG_BOX.COLOR
                                                            v-on="on"
                                                    >
                                                        <v-icon left>mdi-palette</v-icon>
                                                        Färg

                                                    </v-btn>
                                                </template>
                                                <v-color-picker hide-inputs dark style="z-index: 1000;" :value="setup.BG_BOX.COLOR" v-model="setup.BG_BOX.COLOR" class="ma-2"></v-color-picker>
                                            </v-menu>
                                                <v-btn :disabled="setup.BG_BOX.COLOR==='#00000000'" icon @click="setup.BG_BOX.COLOR='#00000000'">
                                                    <v-icon >mdi-close</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-col>
                                        <v-col style="max-width: 100px !important;">
                                            <v-card-subtitle style="text-align:center;margin-bottom:0;">eller</v-card-subtitle>

                                        </v-col>
                                        <v-col style="max-width:400px !important;">
                                            <div class="text-center">
                                            <v-btn style="width:250px;" @click="updateBgImage" >
                                                <v-icon left>mdi-upload</v-icon>
                                                Media
                                            </v-btn>
                                            <v-btn :disabled="(setup.BG_BOX.IMAGE===false && setup.BG_BOX.VIDEO===false && setup.BG_BOX.GIF===false)"  icon @click="setup.BG_BOX.IMAGE=false; setup.BG_BOX.VIDEO=false ;setup.BG_BOX.GIF=false">
                                                <v-icon >mdi-close</v-icon>
                                            </v-btn>
                                            </div>
                                        </v-col>

                                    </v-row>



                                </v-card>
                            </v-tab-item>
                            <v-tab-item eager style="" transition="false" reverse-transition="false">
                                <v-btn
                                        @click="reset_message"
                                        style="position: absolute;top:14px;right:10px;z-index: 3;"
                                        icon >
                                    <v-icon>mdi-redo</v-icon>
                                </v-btn>
                                <v-checkbox
                                        off-icon="mdi-eye-off"
                                        on-icon="mdi-eye"
                                        style="position: absolute;top:0;right:50px;z-index: 3;"
                                        color="gray"
                                        v-model="setup.MESSAGE_BOX.SHOW"
                                >
                                </v-checkbox>
                                <v-card style="" color="#252525" elevation="20" class="pa-12">
                                    <v-card-subtitle style="text-align:center;margin-bottom:0;margin-top:-40px;">- Animation -</v-card-subtitle>
                                    <v-row
                                            style="background:#1f1f1f;border-radius:10px;"

                                    >
                                        <v-col >

                                            <v-range-slider
                                                    v-model="setup.MESSAGE_BOX.RANGE"
                                                    :max="setup.DURATION"
                                                    :min="0"
                                                    hide-details
                                                    :step="0.1"
                                                    class="align-center"
                                                    ref="message_box_range"

                                            >
                                                <template v-slot:prepend>
                                                    <v-text-field
                                                            :value="setup.MESSAGE_BOX.RANGE[0]"
                                                            class="mt-0 pt-0"
                                                            hide-details
                                                            single-line
                                                            type="number"
                                                            style="width: 60px"
                                                            suffix="s"
                                                            @change="$set(setup.MESSAGE_BOX.RANGE, 0, $event)"
                                                    ></v-text-field>
                                                </template>
                                                <template v-slot:append>
                                                    <v-text-field
                                                            :value="setup.MESSAGE_BOX.RANGE[1]"
                                                            class="mt-0 pt-0"
                                                            hide-details
                                                            single-line
                                                            suffix="s"
                                                            type="number"
                                                            style="width: 60px"
                                                            @change="$set(setup.MESSAGE_BOX.RANGE, 1, $event)"
                                                    ></v-text-field>
                                                </template>
                                            </v-range-slider>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-select
                                                    style="margin-top: -8px;"
                                                    :items="animations"
                                                    label="Animation"
                                                    clearable
                                                    hide-details
                                                    v-model="setup.MESSAGE_BOX.ANIMATION"

                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-card-subtitle style="text-align:center;margin-bottom:0;">- Text -</v-card-subtitle>

                                    <v-row style="background:#1f1f1f;border-radius:10px;" justify="center">
                                        <v-col  justify="center" cols="5">
                                            <v-menu
                                                    v-model="message_box_color_menu"
                                                    :close-on-content-click="false"
                                                    :nudge-width="200"
                                                    offset-x
                                                    dark
                                                    content-class="color_menu"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                            style="text-shadow: 4px 4px 20px black;"
                                                            class="mx-2 my-2"
                                                            :color=setup.MESSAGE_BOX.COLOR
                                                            v-on="on"
                                                            block
                                                    >Textfärg</v-btn>
                                                </template>
                                                <v-color-picker style="z-index: 1000;" v-model="setup.MESSAGE_BOX.COLOR" class="ma-2"></v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="5">
                                            <font-picker
                                                    :options="{
                                        name: 'message'+id_given
                                        }"
                                                    style="color:white;top: 8px;width: 100%;"
                                                    :active-font="setup.MESSAGE_BOX.FONT"
                                                    :api-key="'AIzaSyDAiLD4uruyYeaub20yX_zJpWtagUarpWA'"
                                                    v-on:change="setMessageFont"
                                                    class="font_pick"
                                            ></font-picker>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-text-field
                                                    v-model="setup.MESSAGE_BOX.FONT_SIZE"
                                                    class="give_me_spin"
                                                    hide-details
                                                    single-line
                                                    type="number"
                                                    style="width: 60px;margin-top:-4px;"
                                                    suffix="px"
                                            ></v-text-field>
                                        </v-col>

                                    </v-row>





                                </v-card>

                            </v-tab-item>
                            <v-tab-item eager style="" transition="false" reverse-transition="false">
                                <v-btn
                                        @click="reset_name"
                                        style="position: absolute;top:14px;right:10px;z-index: 3;"
                                        icon >
                                    <v-icon>mdi-redo</v-icon>
                                </v-btn>
                                <v-checkbox
                                        off-icon="mdi-eye-off"
                                        on-icon="mdi-eye"
                                        style="position: absolute;top:0;right:50px;z-index: 3;"
                                        color="gray"
                                        v-model="setup.NAME_BOX.SHOW"
                                >
                                </v-checkbox>
                                <v-card style="" color="#252525" elevation="20" class="pa-12">
                                    <v-card-subtitle style="text-align:center;margin-bottom:0;margin-top:-40px;">- Animation -</v-card-subtitle>
                                    <v-row
                                            style="background:#1f1f1f;border-radius:10px;"

                                    >
                                        <v-col >

                                            <v-range-slider
                                                    v-model="setup.NAME_BOX.RANGE"
                                                    :max="setup.DURATION"
                                                    :min="0"
                                                    :step="0.1"
                                                    hide-details
                                                    class="align-center"
                                                    ref="name_box_range"

                                            >
                                                <template v-slot:prepend>
                                                    <v-text-field
                                                            :value="setup.NAME_BOX.RANGE[0]"
                                                            class="mt-0 pt-0"
                                                            hide-details
                                                            single-line
                                                            type="number"
                                                            style="width: 60px"
                                                            suffix="s"
                                                            @change="$set(setup.NAME_BOX.RANGE, 0, $event)"
                                                    ></v-text-field>
                                                </template>
                                                <template v-slot:append>
                                                    <v-text-field
                                                            :value="setup.NAME_BOX.RANGE[1]"
                                                            class="mt-0 pt-0"
                                                            hide-details
                                                            single-line
                                                            suffix="s"
                                                            type="number"
                                                            style="width: 60px"
                                                            @change="$set(setup.NAME_BOX.RANGE, 1, $event)"
                                                    ></v-text-field>
                                                </template>
                                            </v-range-slider>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-select
                                                    style="margin-top: -8px;"
                                                    :items="animations"
                                                    label="Animation"
                                                    clearable
                                                    hide-details
                                                    v-model="setup.NAME_BOX.ANIMATION"

                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-card-subtitle style="text-align:center;margin-bottom:0;">- Text -</v-card-subtitle>

                                    <v-row style="background:#1f1f1f;border-radius:10px;" justify="center">
                                        <v-col  justify="center" class="col-5 col-lg-3">
                                            <v-menu
                                                    v-model="name_box_color_menu"
                                                    :close-on-content-click="false"
                                                    :nudge-width="200"
                                                    offset-x
                                                    dark
                                                    content-class="color_menu"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                            style="text-shadow: 4px 4px 20px black;"
                                                            class="mx-2 my-2"
                                                            :color=setup.NAME_BOX.COLOR
                                                            v-on="on"
                                                            block
                                                    >Textfärg</v-btn>
                                                </template>
                                                <v-color-picker style="z-index: 1000;" v-model="setup.NAME_BOX.COLOR" class="ma-2"></v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col class="col-5 col-lg-3">
                                            <font-picker
                                                    :options="{
                                        name: 'name'+id_given
                                        }"
                                                    style="color:white;top: 8px;width: 100%;"
                                                    :active-font="setup.NAME_BOX.FONT"
                                                    :api-key="'AIzaSyDAiLD4uruyYeaub20yX_zJpWtagUarpWA'"
                                                    v-on:change="setNameFont"
                                                    class="font_pick"
                                            ></font-picker>
                                        </v-col>
                                        <v-col   class="col-2 col-lg-1">
                                            <v-text-field
                                                    v-model="setup.NAME_BOX.FONT_SIZE"
                                                    class="give_me_spin"
                                                    hide-details
                                                    single-line
                                                    type="number"
                                                    style="width: 60px;margin-top:-4px;"
                                                    suffix="px"
                                            ></v-text-field>
                                        </v-col>


                                        <v-col  class="col-12 col-lg-5">
                                        <v-text-field
                                                v-model="setup.NAME_BOX.TEMPLATE"
                                                label="Template"
                                                dense
                                                outlined
                                                hide-details
                                        >

                                            <template v-slot:label>
                                                Använd <strong>&lt;NAMN&gt;</strong> och/eller <strong>&lt;SUMMA&gt;</strong>
                                            </template>


                                        </v-text-field>
                                        </v-col>
                                    </v-row>



                                </v-card>
                            </v-tab-item>
                            <v-tab-item eager style="" transition="false" reverse-transition="false">
                                <v-btn
                                        @click="reset_amount"
                                        style="position: absolute;top:14px;right:10px;z-index: 3;"
                                        icon >
                                    <v-icon>mdi-redo</v-icon>
                                </v-btn>
                                <v-checkbox
                                        off-icon="mdi-eye-off"
                                        on-icon="mdi-eye"
                                        style="position: absolute;top:0;right:50px;z-index: 3;"
                                        color="gray"
                                        v-model="setup.AMOUNT_BOX.SHOW"
                                >
                                </v-checkbox>
                                <v-card style="" color="#252525" elevation="20" class="pa-12">
                                    <v-card-subtitle style="text-align:center;margin-bottom:0;margin-top:-40px;">- Animation -</v-card-subtitle>
                                    <v-row
                                            style="background:#1f1f1f;border-radius:10px;"

                                    >
                                        <v-col >

                                            <v-range-slider
                                                    v-model="setup.AMOUNT_BOX.RANGE"
                                                    :max="setup.DURATION"
                                                    :min="0"
                                                    :step="0.1"
                                                    hide-details
                                                    class="align-center"
                                                    ref="amount_box_range"

                                            >
                                                <template v-slot:prepend>
                                                    <v-text-field
                                                            :value="setup.AMOUNT_BOX.RANGE[0]"
                                                            class="mt-0 pt-0"
                                                            hide-details
                                                            single-line
                                                            type="number"
                                                            style="width: 60px"
                                                            suffix="s"
                                                            @change="$set(setup.AMOUNT_BOX.RANGE, 0, $event)"
                                                    ></v-text-field>
                                                </template>
                                                <template v-slot:append>
                                                    <v-text-field
                                                            :value="amount_range[1]"
                                                            class="mt-0 pt-0"
                                                            hide-details
                                                            single-line
                                                            suffix="s"
                                                            type="number"
                                                            style="width: 60px"
                                                            @change="$set(setup.AMOUNT_BOX.RANGE, 1, $event)"
                                                    ></v-text-field>
                                                </template>
                                            </v-range-slider>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-select
                                                    style="margin-top: -8px;"
                                                    :items="animations"
                                                    label="Animation"
                                                    clearable
                                                    hide-details
                                                    v-model="setup.AMOUNT_BOX.ANIMATION"

                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-card-subtitle style="text-align:center;margin-bottom:0;">- Text -</v-card-subtitle>

                                    <v-row style="background:#1f1f1f;border-radius:10px;" justify="center">
                                        <v-col  justify="center" class="col-5 col-lg-3">
                                            <v-menu
                                                    v-model="amount_box_color_menu"
                                                    :close-on-content-click="false"
                                                    :nudge-width="200"
                                                    offset-x
                                                    dark
                                                    content-class="color_menu"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                            style="text-shadow: 4px 4px 20px black;"
                                                            class="mx-2 my-2"
                                                            :color=setup.AMOUNT_BOX.COLOR
                                                            v-on="on"
                                                            block
                                                    >Textfärg</v-btn>
                                                </template>
                                                <v-color-picker style="z-index: 1000;"  v-model="setup.AMOUNT_BOX.COLOR" class="ma-2"></v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col class="col-5 col-lg-3">
                                            <font-picker
                                                    :options="{
                                        name: 'amount'+id_given
                                        }"
                                                    style="color:white;top: 8px;width: 100%;"
                                                    :active-font="setup.AMOUNT_BOX.FONT"
                                                    :api-key="'AIzaSyDAiLD4uruyYeaub20yX_zJpWtagUarpWA'"
                                                    v-on:change="setAmountFont"
                                                    class="font_pick"
                                            ></font-picker>
                                        </v-col>
                                        <v-col class="col-2 col-lg-1">
                                            <v-text-field
                                                    v-model="setup.AMOUNT_BOX.FONT_SIZE"
                                                    class="give_me_spin"
                                                    hide-details
                                                    single-line
                                                    type="number"
                                                    style="width: 60px;margin-top:-4px;"
                                                    suffix="px"
                                            ></v-text-field>
                                        </v-col>


                                        <v-col class="col-12 col-lg-5">
                                        <v-text-field
                                                v-model="setup.AMOUNT_BOX.TEMPLATE"
                                                label="Template"
                                                dense
                                                outlined
                                                hide-details

                                        >

                                            <template v-slot:label>
                                                Använd <strong>&lt;NAMN&gt;</strong> och/eller <strong>&lt;SUMMA&gt;</strong>
                                            </template>


                                        </v-text-field>
                                        </v-col>
                                    </v-row>



                                </v-card>
                            </v-tab-item>

                        </v-tabs-items>
                    </v-col>
                </v-row>
            </v-col>



        </v-row>



        <v-row align="center" justify="center" v-if="type==='DONATION'">
            <v-col align="center" justify="center" style="max-width:1200px;">
                <v-card style="" color="#252525" elevation="20" class="pa-12">
                    <v-card-subtitle style="text-align:center;margin-bottom:0;margin-top:-40px;">- Ljud -</v-card-subtitle>
                    <v-row
                            style="background:#1f1f1f;border-radius:10px;"

                    >   <v-col>

                        <div class="text-center">
                            <v-btn v-if="!audioPlaying" :disabled="setup.SOUND===false"  @click="playAlertSound" icon >
                                <v-icon >mdi-play</v-icon>

                            </v-btn>
                            <v-btn v-else  @click="stopAlertSound" icon >
                                <v-icon >mdi-pause</v-icon>

                            </v-btn>

                            <v-btn style="width:200px;" @click="updateAlertSound">
                                <v-icon left>mdi-upload</v-icon>
                                Ladda upp
                            </v-btn>
                            <v-btn :disabled="setup.SOUND===false" icon @click="setup.SOUND=false">
                                <v-icon >mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-col>

                    </v-row>
                    <v-card-subtitle style="text-align:center;margin-bottom:0;">- Text-To-Speech(tts) -</v-card-subtitle>

                    <v-row style="background:#1f1f1f;border-radius:10px;" justify="center" align="center">
                        <v-switch
                                v-model="setup.TTS"
                        ></v-switch>

                        <v-col  justify="center" cols="4" style="margin-top:16px;" >
                            <v-text-field
                                    v-model="setup.MIN_TTS"
                                    class="give_me_spin"
                                    label="Minsta-donation"
                                    outlined
                                    hint="Minsta donation för att spela upp TTS"
                                    dense
                                    :min="setup.MIN_DONATION"
                                    :disabled="setup.TTS===false"

                                    type="number"
                                    suffix="kr"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" style="margin-top:16px;">
                            <div style="display: flex;">

                                <v-select
                                        v-model="setup.TTS"
                                        :disabled="setup.TTS===false"
                                        :items="['Engelska','Svenska','Norska']"
                                        label="Språk"
                                        dense
                                        value="Svenska"
                                        outlined
                                ></v-select>

                            </div>
                        </v-col>



                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row align="center" justify="center" v-if="type==='DONATION'">
            <v-col align="center" justify="center" style="max-width:1200px;">
                <v-card style="" color="#252525" elevation="20" class="pa-12">
                    <v-card-subtitle style="text-align:center;margin-bottom:0;margin-top:-40px;">- Filter -</v-card-subtitle>


                    <v-col cols="12">

                        <v-combobox
                                v-model="setup.BAD_WORDS"
                                :items="[]"
                                label="Lägg till bannlysta ord"
                                multiple
                                small-chips
                                deletable-chips

                        >

                        </v-combobox>

                    </v-col>





                </v-card>
            </v-col>
        </v-row>
        <v-row align="center" justify="center" v-if="type==='GOAL' && !loading">
            <v-col align="center" justify="center" style="max-width:1200px;">
                <v-card style="" color="#252525" elevation="20" class="pa-12">
                    <v-card-subtitle style="text-align:center;margin-bottom:0;margin-top:-40px;">- Bakgrund -</v-card-subtitle>

                    <v-row style="background:#1f1f1f;border-radius:10px;" justify="center" align="center">

                    <v-col style="max-width:400px !important;"   justify="center">
                        <div class="text-center">

                            <v-menu
                                    v-model="background_color_menu"
                                    :close-on-content-click="false"
                                    :nudge-width="200"
                                    offset-x
                                    dark
                                    content-class="color_menu"
                            >
                                <template v-slot:activator="{ on }">

                                    <v-btn
                                            style="text-shadow: 4px 4px 20px black;width:250px;"
                                            class="mx-2 my-2"
                                            :color=setup.BG_BOX.COLOR
                                            v-on="on"
                                    >
                                        <v-icon left>mdi-palette</v-icon>
                                        Färg

                                    </v-btn>
                                </template>
                                <v-color-picker hide-inputs dark style="z-index: 1000;" :value="setup.BG_BOX.COLOR" v-model="setup.BG_BOX.COLOR" class="ma-2"></v-color-picker>
                            </v-menu>
                            <v-btn :disabled="setup.BG_BOX.COLOR==='#00000000'" icon @click="setup.BG_BOX.COLOR='#00000000'">
                                <v-icon >mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-col>

                    <v-col style="max-width:400px !important;">
                        <div class="text-center">
                            <v-btn style="width:250px;" @click="updateBgImage" >
                                <v-icon left>mdi-upload</v-icon>
                                Media
                            </v-btn>
                            <v-btn :disabled="(setup.BG_BOX.IMAGE===false && setup.BG_BOX.VIDEO===false && setup.BG_BOX.GIF===false)"   icon @click="setup.BG_BOX.IMAGE=false; setup.BG_BOX.VIDEO=false; setup.BG_BOX.GIF=false">
                                <v-icon >mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    </v-row>
                    <v-card-subtitle style="text-align:center;margin-bottom:0;">- Text -</v-card-subtitle>


                    <v-row style="background:#1f1f1f;border-radius:10px;" justify="center">
                        <v-col  justify="center" class="col-5 col-lg-3">
                            <v-menu
                                    v-model="amount_box_color_menu"
                                    :close-on-content-click="false"
                                    :nudge-width="200"
                                    offset-x
                                    dark
                                    content-class="color_menu"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                            style="text-shadow: 4px 4px 20px black;"
                                            class="mx-2 my-2"
                                            :color=setup.AMOUNT_BOX.COLOR
                                            v-on="on"
                                            block
                                    >Textfärg</v-btn>
                                </template>
                                <v-color-picker style="z-index: 1000;"  v-model="setup.AMOUNT_BOX.COLOR" class="ma-2"></v-color-picker>
                            </v-menu>
                        </v-col>
                        <v-col class="col-5 col-lg-3">
                            <font-picker
                                    :options="{
                                        name: 'message'+id_given
                                        }"
                                    style="color:white;top: 8px;width: 100%;"
                                    :active-font="setup.MESSAGE_BOX.FONT"
                                    :api-key="'AIzaSyDAiLD4uruyYeaub20yX_zJpWtagUarpWA'"
                                    v-on:change="setMessageFont"
                                    class="font_pick"
                            ></font-picker>
                        </v-col>
                        <v-col class="col-2 col-lg-1">
                            <v-text-field
                                    v-model="setup.AMOUNT_BOX.FONT_SIZE"
                                    class="give_me_spin"
                                    hide-details
                                    single-line
                                    type="number"
                                    style="width: 60px;margin-top:-4px;"
                                    suffix="px"
                            ></v-text-field>
                        </v-col>


                        <v-col class="col-12 col-lg-5">
                            <v-text-field
                                    v-model="setup.AMOUNT_BOX.TEMPLATE"
                                    label="Template"
                                    dense
                                    outlined
                                    hide-details

                            >

                                <template v-slot:label>
                                    Använd <strong>&lt;SUMMA&gt;</strong> och/eller <strong>&lt;TOTAL&gt;</strong>
                                </template>


                            </v-text-field>
                        </v-col>
                    </v-row>






                </v-card>
            </v-col>
        </v-row>


        <input v-if="type==='DONATION'" :id="bg_image_id" style="display:none;" type="file" accept=".webm, .gif, .jpg, .png, .jpeg, .svg"  v-on:change="openBgFile">
        <input v-if="type==='GOAL'" :id="bg_image_id" style="display:none;" type="file" accept=".gif, .jpg, .png, .jpeg, .svg"  v-on:change="openBgFile">

        <input :id="alert_sound_id" style="display:none;" type="file" accept=".mp3, .wav, .ogg"  v-on:change="openSoundFile"  >


    </v-container>
</template>

<script>

    import StandardAlert from "./StandardAlert";
    import GoalAlert from "./GoalAlert";

    import FontPicker from 'font-picker-vue';
    export default {
        name: "DonationOverlay",
        props:["name","data","setup_data","editable","id_given","is_active","type","donation_data"],
        components:{
            StandardAlert,
            FontPicker,
            GoalAlert

        },

        data(){
            return{
                loading:"teal",
                animations:["bounce","bounceDown","bounceLeft","bounceRight","bounceUp","fade","fadeDown","fadeDownBig","fadeLeft","fadeLeftBig","fadeRight","fadeRightBig","fadeUp","fadeUpBig","flip","flipX","flipY","rotate","rotateDownLeft","rotateDownRight","rotateUpLeft","rotateUpRight","slideDown","slideLeft","slideRight","slideUp","zoom","zoomDown","zoomLeft","zoomRight","zoomUp","lightSpeed"],
                lock_alert:true,
                alert_duration:10,
                background_range:[0, 10],
                amount_range:[0, 10],
                message_range:[0, 10],
                name_range:[0, 10],
                edit_box_tab:0,
                setup:{

                },
                max_donation:false,
                amounts:[25,150,69,450,15,100,500,45,37,200],
                background_color_menu:false,
                message_box_color_menu:false,
                name_box_color_menu:false,
                amount_box_color_menu:false,

                audioPlaying:false,
                windowWidth: window.innerWidth


            }
        },
        computed:{
            url:function(){
                return window.location.origin+"/widget_do?id="+this.id_given;
            },
            bg_image_id:function(){
                return "bg_image_"+this.id_given
            },
            alert_sound_id:function(){
                return "alert_sound_"+this.id_given
            },
            scale:function(){
                if(this.windowWidth>1000){
                    return ""
                }
                else{
                    return `scale(${this.windowWidth/1050})`
                }
            }


        },
        methods:{
            set_max:function(){
                this.max_donation=!this.max_donation;
                if(!this.max_donation){
                    this.setup.MAX_DONATION=null
                }
                else{
                    this.setup.MAX_DONATION=null;

                }
            },

            send_test:function(){
                this.lock_alert=false;
                let AMOUNT=this.donation_data.AMOUNT;
                let MESSAGE=this.donation_data.MESSAGE;
                let NAME=this.donation_data.SENDER_NAME;
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/api_test_hihat';


                let params ="AMOUNT="+AMOUNT+"&MESSAGE="+MESSAGE+"&NAME="+NAME;
                //let self=this;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status === 200) {
                        console.log("sent!")
                    }
                    else if(http.readyState === 4 && http.status !== 200) {
                        console.log("error")
                    }
                };
                http.send(params);
                if(this.type==="DONATION"){
                    this.$refs.standard_alert.message();
                }
                else if(this.type==="GOAL"){
                    this.$refs.goal_alert.extra_raised+=parseInt(this.donation_data.AMOUNT);
                }





            },

            save_setup:function(){
                if(this.type==="DONATION"){
                    let new_setup=this.$refs.standard_alert.save();

                    if(this.setup.BG_BOX.SHOW){
                        this.setup.BG_BOX.X=new_setup.BG_BOX.X;
                        this.setup.BG_BOX.Y=new_setup.BG_BOX.Y;
                        this.setup.BG_BOX.WIDTH=new_setup.BG_BOX.WIDTH;
                        this.setup.BG_BOX.HEIGHT=new_setup.BG_BOX.HEIGHT;
                    }

                    if(this.setup.MESSAGE_BOX.SHOW){
                        this.setup.MESSAGE_BOX.X=new_setup.MESSAGE_BOX.X;
                        this.setup.MESSAGE_BOX.Y=new_setup.MESSAGE_BOX.Y;
                        this.setup.MESSAGE_BOX.WIDTH=new_setup.MESSAGE_BOX.WIDTH;
                        this.setup.MESSAGE_BOX.HEIGHT=new_setup.MESSAGE_BOX.HEIGHT;
                    }


                    if(this.setup.NAME_BOX.SHOW){
                        this.setup.NAME_BOX.X=new_setup.NAME_BOX.X;
                        this.setup.NAME_BOX.Y=new_setup.NAME_BOX.Y;
                        this.setup.NAME_BOX.WIDTH=new_setup.NAME_BOX.WIDTH;
                        this.setup.NAME_BOX.HEIGHT=new_setup.NAME_BOX.HEIGHT;
                    }

                    if(this.setup.AMOUNT_BOX.SHOW){
                        this.setup.AMOUNT_BOX.X=new_setup.AMOUNT_BOX.X;
                        this.setup.AMOUNT_BOX.Y=new_setup.AMOUNT_BOX.Y;
                        this.setup.AMOUNT_BOX.WIDTH=new_setup.AMOUNT_BOX.WIDTH;
                        this.setup.AMOUNT_BOX.HEIGHT=new_setup.AMOUNT_BOX.HEIGHT;
                    }
                }
                else if(this.type==="GOAL"){
                    let new_setup=this.$refs.goal_alert.save();

                    this.setup.MESSAGE_BOX.X=new_setup.MESSAGE_BOX.X;
                    this.setup.MESSAGE_BOX.Y=new_setup.MESSAGE_BOX.Y;
                    this.setup.MESSAGE_BOX.WIDTH=new_setup.MESSAGE_BOX.WIDTH;
                    this.setup.MESSAGE_BOX.HEIGHT=new_setup.MESSAGE_BOX.HEIGHT;
                }


            },

            delete:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/delete_donation_widget';


                let params ="ID="+this.id_given;
                let self=this;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status === 200) {
                        self.$emit("deleted");


                    }
                };
                http.send(params);
            },

            save:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                this.save_setup();
                let url = '/api/update_donation_widget';
                let NEW_VIDEO="0";
                let NEW_IMAGE="0";
                let NEW_GIF="0";
                let NEW_SOUND="0";
                let setup_clone=JSON.parse(JSON.stringify(this.setup));
                if(this.setup.BG_BOX.VIDEO!==false){
                    if(this.setup.BG_BOX.VIDEO.substring(0,4)==="data"){
                        NEW_VIDEO=this.setup.BG_BOX.VIDEO;
                    }
                    setup_clone.BG_BOX.VIDEO=`/api/images/donation/${this.id_given}.webm`

                }
                if(this.setup.SOUND!==false){
                    if(this.setup.SOUND.substring(0,4)==="data"){
                        NEW_SOUND=this.setup.SOUND;
                        if(this.setup.SOUND[11].toLowerCase()==="w"){
                            setup_clone.SOUND=`/api/images/donation/${this.id_given}.wav`
                        }
                        else if(this.setup.SOUND[11].toLowerCase()==="m"){
                            setup_clone.SOUND=`/api/images/donation/${this.id_given}.mp3`
                        }
                        else if(this.setup.SOUND[11].toLowerCase()==="o"){
                            setup_clone.SOUND=`/api/images/donation/${this.id_given}.ogg`
                        }
                    }


                }

                if(this.setup.BG_BOX.IMAGE!==false){
                    if(this.setup.BG_BOX.IMAGE.substring(0,4)==="data"){
                        NEW_IMAGE=this.setup.BG_BOX.IMAGE;
                        if(this.setup.BG_BOX.IMAGE[11].toLowerCase()==="p"){
                            setup_clone.BG_BOX.IMAGE=`/api/images/donation/${this.id_given}.png`
                        }
                        else if(this.setup.BG_BOX.IMAGE[11].toLowerCase()==="j"){
                            setup_clone.BG_BOX.IMAGE=`/api/images/donation/${this.id_given}.jpeg`
                        }


                    }
                }
                else if(this.setup.BG_BOX.GIF!==false){
                    if(this.setup.BG_BOX.GIF.substring(0,4)==="data"){
                        NEW_GIF=this.setup.BG_BOX.GIF;
                        setup_clone.BG_BOX.GIF=`/api/images/donation/${this.id_given}.gif`

                    }
                }
                let setup=JSON.stringify(setup_clone);


                let params ="SETUP="+setup+"&ID="+this.id_given+"&NEW_VIDEO="+NEW_VIDEO+"&NEW_IMAGE="+NEW_IMAGE+"&NEW_GIF="+NEW_GIF+"&NEW_SOUND="+NEW_SOUND+"&NAME="+this.name;

                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.
                    console.log(http.status);
                };
                http.send(params);
            },

            openBgFile:function(file) {

                let input = file.target;


                let reader = new FileReader();
                let self=this;
                reader.onload = function(){
                    console.log(reader);
                    if(reader.result.substring(0,15)==="data:video/webm"){
                        self.setup.BG_BOX.IMAGE=false;
                        self.setup.BG_BOX.GIF=false;
                        self.setup.BG_BOX.VIDEO=reader.result;
                    }
                    else if(reader.result.substring(0,14)==="data:image/gif"){
                        self.setup.BG_BOX.IMAGE=false;
                        self.setup.BG_BOX.GIF=reader.result;
                        self.setup.BG_BOX.VIDEO=false
                    }
                    else{
                        self.setup.BG_BOX.IMAGE=reader.result;
                        self.setup.BG_BOX.GIF=false;
                        self.setup.BG_BOX.VIDEO=false
                    }
                };
                reader.readAsDataURL(input.files[0]);
            },
            openSoundFile:function(file) {

                let input = file.target;


                let reader = new FileReader();
                let self=this;
                reader.onload = function(){
                    console.log(reader);
                    self.setup.SOUND=reader.result;
                };
                reader.readAsDataURL(input.files[0]);
            },
            playAlertSound:function(){
                this.audioPlaying=new Audio(this.setup.SOUND);
                this.audioPlaying.play();
                let self=this;
                this.audioPlaying.addEventListener("ended", function(){
                    self.audioPlaying=false;

                });

            },
            stopAlertSound:function(){
                this.audioPlaying.pause();
                this.audioPlaying.currentTime = 0;
                this.audioPlaying=false;
            },
            updateBgImage:function(){
                document.getElementById(this.bg_image_id).click();
            },
            updateAlertSound:function(){
                document.getElementById(this.alert_sound_id).click();
            },
            setMessageFont(font){
              this.setup.MESSAGE_BOX.FONT=font.family;
            },
            setNameFont(font){
                this.setup.NAME_BOX.FONT=font.family;
            },
            setAmountFont(font){
                this.setup.AMOUNT_BOX.FONT=font.family;
            },
            handleFocus(focusIndex){
              this.edit_box_tab=focusIndex;
            },
            glow(element,glow){
                let elem=document.getElementById(element);
                if(glow){
                  if(elem){
                      elem.classList.add("glow");
                  }
              }
              else{
                    if(elem) {
                        document.getElementById(element).classList.remove("glow");
                    }
              }
            },
            reset_all(){
                this.reset_bg();
                this.reset_message();
                this.reset_amount();
                this.reset_name();


            },
            reset_bg(){
                this.setup_default_bg();
                this.$refs.standard_alert.reset_bg(this.setup);
            },
            reset_message(){
                this.setup_default_message();
                this.$refs.standard_alert.reset_message(this.setup);
            },
            reset_amount(){
                this.setup_default_amount();
                this.$refs.standard_alert.reset_amount(this.setup);
            },
            reset_name(){
                this.setup_default_name();
                this.$refs.standard_alert.reset_name(this.setup);
            },
            setup_default_bg(){
                this.setup.BG_BOX={
                            COLOR:"rgba(25,25,25,0.0)",
                            WIDTH:425,
                            HEIGHT:288,
                            Y:150,
                            X:85,
                            IMAGE:false,
                            VIDEO:false,
                            ANIMATION:"",
                            SHOW:true
                        }
            },
            setup_default_message(){
                this.setup.MESSAGE_BOX={
                    COLOR:"rgba(255,255,255,1)",
                    WIDTH:370,
                    HEIGHT:150,
                    Y:216,
                    X:112,
                    IMAGE:false,
                    VIDEO:false,
                    ANIMATION:"",
                    FONT:"Roboto",
                    SHOW:true

                }
            },
            setup_default_amount(){
                this.setup.AMOUNT_BOX={
                    COLOR:"rgba(255,255,255,1)",
                    WIDTH:435,
                    HEIGHT:40,
                    Y:150,
                    X:80,
                    IMAGE:false,
                    VIDEO:false,
                    ANIMATION:"",
                    FONT:"Roboto",
                    FONT_SIZE:"10",

                    SHOW:true

                }
            },
            setup_default_name(){
                this.setup.NAME_BOX={
                    COLOR:"rgba(255,255,255,1)",
                    WIDTH:370,
                    HEIGHT:33,
                    Y:426,
                    X:112,
                    IMAGE:false,
                    VIDEO:false,
                    ANIMATION:"",
                    FONT:"Roboto",
                    FONT_SIZE:"10",
                    SHOW:true

                }
            },
            goHome:function(){
                this.$router.push({ path: '/' })
            },


            getSetup(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/get_donation_widget';
                http.open('GET', url, true);

                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.
                    //console.log(http.status);
                    if(http.readyState === 4 && http.status === 401) {
                        console.log("error getting user data");
                    }
                    else if(http.readyState === 4 && http.status === 200){
                        let data = JSON.parse(http.response);
                        if(data.error==="no data"){
                            console.log("error");
                        }
                        self.loading=false;



                    }
                };
                http.send();
            },
            colorMe(amount){
                if(parseInt(amount)>499){
                    return "orange"
                }
                else if(parseInt(amount)>99){
                    return "purple"
                }
                else if(parseInt(amount)>49){
                    return "blue"
                }
                else if(parseInt(amount)>20){
                    return "green"
                }
                else{
                    return "#3f3f3f"
                }
            },
            onResize() {
                this.windowWidth = window.innerWidth
            }



        },
        mounted:function(){
            //this.setupDefault();
            this.$emit("show");
            if(this.editable){
                this.setup=this.setup_data;
                if(this.setup.MAX_DONATION){
                    this.max_donation=true;
                }

            }
            this.loading=false;

            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
            console.log("IM HERE! "+this.name);

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        watch: {
            "setup.DURATION": function () {
                let self = this;
                setTimeout(function () {
                    if (self.$refs.bg_box_range) {
                        self.$refs.bg_box_range.$el.getElementsByClassName("v-slider__thumb")[0].click();
                    }
                    if (self.$refs.message_box_range) {
                        self.$refs.message_box_range.$el.getElementsByClassName("v-slider__thumb")[0].click();
                    }
                    if (self.$refs.amount_box_range) {
                        self.$refs.amount_box_range.$el.getElementsByClassName("v-slider__thumb")[0].click();
                    }
                    if (self.$refs.name_box_range) {
                        self.$refs.name_box_range.$el.getElementsByClassName("v-slider__thumb")[0].click();
                    }


                }, 50)
                /*
                 if(this.is_active){
                    this.$emit("register",this)
                }
                 */

            },
            "setup.TTS":function(){
                if(this.setup.TTS===true){
                    this.setup.TTS="Svenska";
                }
            },
            is_active: {
                immediate: true,
                handler() {
                    if (this.is_active) {
                        this.$emit("register", this)
                    }
                }

            }
        }


    }
</script>

<style lang="scss">
    iframe { width:100%;height:100%; }
    .glow{
        box-shadow: 1px 1px 19px 6px rgba(255,255,255,0.75);
        -webkit-box-shadow: 1px 1px 19px 6px rgba(255,255,255,0.75);
        -moz-box-shadow: 1px 1px 19px 6px rgba(255,255,255,0.75);
    }
    .v-slider{
        top:16px;
    }
    .v-expansion-panel-header{
        padding-bottom:0;
    }
    .color_menu{
        min-width: 0 !important;
    }

    .color_menu > div{
        margin:0 !important;
    }

    .font_pick > button{
        border-radius:4px;
        background: #1d1d1d !important;
        color:white !important;
    }
    .font_pick > *{
        color:white !important;
        background: #1d1d1d !important;
    }
    .font_pick > *{
        color:white !important;
        background: #1d1d1d !important;
    }


    .dropdown-icon {
        &.loading:before {

            border: 2px solid white !important;
            border-top-color: white !important;

        }
        &.finished:before {

            border-top: 6px solid white !important;

        }

    }

    .handle{
        width: 10px;
        height: 10px;
        background: #009688;
        border: 1px solid #44d6c8;
        border-radius: 5px;
    }








</style>
